import script from "./alarmTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmTemplate.vue?vue&type=script&setup=true&lang=js"

import "./alarmTemplate.vue?vue&type=style&index=0&id=fb642de4&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb642de4"]])

export default __exports__